import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usr-excelexport',
  templateUrl: './usr-excelexport.component.html',
  styleUrls: ['./usr-excelexport.component.css']
})
export class UsrExcelexportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
